/** Structured data mirrors public on-page content for server-rendered responses. */
export const homepageSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What does a title company do in Florida?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "A title company researches the public records to confirm the seller has the right to transfer the property, identifies liens, judgments, and other issues that must be cleared, holds funds in escrow, prepares the settlement statement, conducts the closing, records the documents with the county, and issues title insurance policies that protect the buyer and lender."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need title insurance?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "If you are financing your purchase, your lender will require a lender's title insurance policy. An owner's title insurance policy is optional, but it is strongly recommended because it protects you against covered title defects, such as undisclosed liens, forgery, or errors in the public records, for as long as you or your heirs own the property."
        }
      },
      {
        "@type": "Question",
        "name": "Who pays for the owner's title insurance policy in South Florida?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "It is negotiable and is set by your purchase contract. In Miami-Dade and Broward counties, the buyer customarily pays for the owner's policy, while in Palm Beach County and many other parts of Florida, the seller customarily pays. Always review your contract, and contact us if you have questions about your specific transaction."
        }
      },
      {
        "@type": "Question",
        "name": "How much does title insurance cost in Florida?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Florida title insurance premiums are set by state regulation and are based on the purchase price or loan amount, so the base premium is the same regardless of which title company you choose. What differs between companies is settlement and service fees, and the level of service you receive. Request a title quote for a detailed estimate for your transaction."
        }
      },
      {
        "@type": "Question",
        "name": "How long does a closing take?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Timing depends on the transaction. Financed purchases often take 30 to 45 days, mostly driven by the lender's approval process. Cash transactions can close sooner once title is clear. Condominium and HOA approvals can add time, so we recommend starting the approval process as early as possible."
        }
      },
      {
        "@type": "Question",
        "name": "What is an estoppel certificate?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "An estoppel certificate is a statement from a condominium or homeowners association showing the dues, assessments, and any other amounts owed on a property as of a specific date. We obtain it before closing so any balances are paid and the buyer does not inherit the seller's unpaid obligations."
        }
      },
      {
        "@type": "Question",
        "name": "Can I close if I am not in Florida?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "In many cases, yes. Depending on your lender and the transaction, documents can be signed remotely through a mail-away closing or remote online notarization. Contact our team to confirm the options available for your closing."
        }
      },
      {
        "@type": "Question",
        "name": "How can I protect myself from wire fraud?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Before sending any funds, always confirm wiring instructions by calling our office directly at (305) 605-3931, using a phone number you know is correct rather than one provided in an email. Treat any email asking you to change wiring instructions as suspicious and call us before taking action."
        }
      },
      {
        "@type": "Question",
        "name": "How do I start a title order?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can open an order online through our Order Title page, call us at (305) 605-3931, or email assistant@mypremiertitle.com. Please have your executed purchase contract and the contact information for all parties ready."
        }
      }
    ]
  },
  {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "InsuranceAgency",
        "@id": "https://mypremiertitle.com/#business",
        "name": "Premier Title Solutions",
        "url": "https://mypremiertitle.com/",
        "description": "Premier Title Solutions provides title insurance and escrow services for residential and commercial closings in Aventura, Miami-Dade, Broward, and throughout Florida.",
        "logo": "https://mypremiertitle.com/manus-storage/footer-logo_4e602c21.webp",
        "image": "https://mypremiertitle.com/og-image.jpg",
        "telephone": "+1-305-605-3931",
        "email": "assistant@mypremiertitle.com",
        "priceRange": "Contact for quote",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "20900 NE 30th Ave Ste 503",
          "addressLocality": "Aventura",
          "addressRegion": "FL",
          "postalCode": "33180",
          "addressCountry": "US"
        },
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday"
            ],
            "opens": "09:00",
            "closes": "17:00"
          }
        ],
        "areaServed": [
          {
            "@type": "City",
            "name": "Aventura"
          },
          {
            "@type": "AdministrativeArea",
            "name": "Miami-Dade County"
          },
          {
            "@type": "AdministrativeArea",
            "name": "Broward County"
          },
          {
            "@type": "State",
            "name": "Florida"
          }
        ],
        "knowsLanguage": [
          "en",
          "es",
          "ru",
          "fr"
        ],
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+1-305-605-3931",
          "contactType": "customer service",
          "areaServed": "US-FL",
          "availableLanguage": [
            "English",
            "Spanish",
            "Russian",
            "French"
          ],
          "hoursAvailable": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday"
              ],
              "opens": "09:00",
              "closes": "17:00"
            }
          ]
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Title and Escrow Services",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Title Insurance",
                "provider": {
                  "@id": "https://mypremiertitle.com/#business"
                }
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Escrow Services",
                "provider": {
                  "@id": "https://mypremiertitle.com/#business"
                }
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Residential Real Estate Closings",
                "provider": {
                  "@id": "https://mypremiertitle.com/#business"
                }
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Commercial Real Estate Closings",
                "provider": {
                  "@id": "https://mypremiertitle.com/#business"
                }
              }
            }
          ]
        },
        "sameAs": [
          "https://www.instagram.com/premiertitlesolutions"
        ]
      },
      {
        "@type": "WebSite",
        "@id": "https://mypremiertitle.com/#website",
        "url": "https://mypremiertitle.com/",
        "name": "Premier Title Solutions",
        "publisher": {
          "@id": "https://mypremiertitle.com/#business"
        },
        "inLanguage": "en-US"
      },
      {
        "@type": "WebPage",
        "@id": "https://mypremiertitle.com/#webpage",
        "url": "https://mypremiertitle.com/",
        "name": "Title & Escrow Company in Aventura, FL | Premier Title Solutions",
        "isPartOf": {
          "@id": "https://mypremiertitle.com/#website"
        },
        "about": {
          "@id": "https://mypremiertitle.com/#business"
        },
        "inLanguage": "en-US"
      }
    ]
  }
] as Record<string, unknown>[];

export const publicFaqItems = [
  {
    "question": "What documents do I need to provide?",
    "answer": "It depends on your role. Listing agents need the MLS listing sheet and seller information. Buyers' agents need the purchase contract and buyer identification. Lenders need loan details and property information. If you're buying or selling independently, we'll ask for the property address and proof of identity. You can upload documents securely through our portal."
  },
  {
    "question": "How long does the title search take?",
    "answer": "Most title searches are completed within 24-48 hours of file submission. Complex transactions or those involving title defects may take longer. We'll keep you updated on the status of your file throughout the process."
  },
  {
    "question": "What is a title search and title insurance?",
    "answer": "A title search examines public records to confirm ownership and identify any liens, claims, or other issues affecting the property. Title insurance protects you and your lender against potential future claims on the property. In Florida, a title search is essential before any transaction closes."
  },
  {
    "question": "How much does title insurance cost in Florida?",
    "answer": "Title insurance costs vary based on the property's sale price or loan amount. We provide a detailed quote once we've reviewed your file. Our rates are competitive and compliant with Florida regulations. We're happy to explain what's included in your quote."
  },
  {
    "question": "Is my information secure when I upload documents?",
    "answer": "Yes. We use industry-standard SSL encryption to protect all documents and personal information you submit through our portal. Your data is stored securely and accessible only to authorized team members working on your transaction."
  },
  {
    "question": "Can I track my file status online?",
    "answer": "Yes. Once your file is open, you can log into your online account to view the status of your title search, any issues found, and upcoming next steps. You'll also receive email updates at key milestones."
  },
  {
    "question": "Do you handle refinances?",
    "answer": "Yes. We handle both purchase refinances and cash-out refinances. The process is similar to a purchase transaction-we'll conduct a title search, confirm ownership, and handle closing and escrow services."
  },
  {
    "question": "Do you handle cash sales?",
    "answer": "Absolutely. Cash sales move quickly since there's no lender involved, but title insurance and escrow services are just as important. We'll guide you through the process step by step."
  },
  {
    "question": "What if the title search reveals issues?",
    "answer": "If we find title issues, we'll contact you immediately to explain what was found and discuss solutions. Common issues include old liens, unpaid taxes, or ownership disputes. Most issues can be resolved before closing, and we'll work with all parties to clear the title."
  },
  {
    "question": "What are typical closing costs?",
    "answer": "Closing costs include title insurance, title search fees, escrow fees, and recording fees. The total varies depending on the transaction type and property price. We'll provide an itemized estimate upfront so there are no surprises."
  },
  {
    "question": "Do you coordinate directly with my lender?",
    "answer": "Yes. We communicate directly with lenders to ensure all requirements are met and nothing delays your closing. We'll send the lender any documentation they need and keep them informed of the title status."
  },
  {
    "question": "What happens at the closing appointment?",
    "answer": "You'll sign all closing documents in front of a notary public. We'll explain each document, answer questions, and collect any remaining funds needed to close. Once everything is signed, we record the deed and fund the transaction."
  },
  {
    "question": "What payment methods do you accept?",
    "answer": "We accept wire transfers, cashier's checks, and certified checks. For your security, we require wire instructions be confirmed by phone before funds are sent. We'll provide detailed wiring instructions and a final settlement statement before your closing appointment."
  }
] as { question: string; answer: string }[];

export const publicServiceSchemas = [
  {
    "id": "rc",
    "title": "Residential Closings",
    "description": "We provide white-glove title and escrow services for residential purchase and sale transactions. Our team manages each closing with care, ensuring accurate documentation, secure fund handling, and timely execution."
  },
  {
    "id": "cc",
    "title": "Commercial Closings",
    "description": "Our firm delivers strategic title and escrow support for commercial real estate transactions of varying size and complexity. We work closely with lenders, attorneys, and investors to ensure each transaction is structured and executed with precision."
  },
  {
    "id": "ti",
    "title": "Title Insurance",
    "description": "We conduct thorough title examinations and issue premium title insurance policies designed to protect ownership interests and mitigate risk. Underwritten by a nationally recognized provider, our solutions deliver security and confidence for buyers, sellers, and lenders."
  },
  {
    "id": "es",
    "title": "Escrow Services",
    "description": "Our escrow services are administered with the highest standards of security, compliance, and transparency. We safeguard funds and documents while ensuring all disbursements are executed accurately and on time."
  }
] as { id: string; title: string; description: string }[];
